import { render, staticRenderFns } from "./finuslugi-prefooter.vue?vue&type=template&id=33ff7ceb&scoped=true"
import script from "./finuslugi-prefooter.vue?vue&type=script&lang=js"
export * from "./finuslugi-prefooter.vue?vue&type=script&lang=js"
import style0 from "./finuslugi-prefooter.vue?vue&type=style&index=0&id=33ff7ceb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ff7ceb",
  null
  
)

export default component.exports